import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntroFlowComponent } from './intro-flow.component';
import { IntroFlowPageModule } from '../intro-flow-page/intro-flow-page.module';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { MotesModalModule } from '../motes-modal/motes-modal.module';
import { SvgMorphModule } from '../svg-morph/svg-morph.module';
import { CookieModule } from '../../cookie/cookie.module';
import { LocationHelpComponent } from '../location-help/location-help';


@NgModule({
    declarations: [IntroFlowComponent],
    imports: [
        CommonModule,
        IntroFlowPageModule,
        SvgIconModule,
        SvgMorphModule,
        MotesModalModule,
        CookieModule,
        LocationHelpComponent
    ],
    exports: [IntroFlowComponent]
})
export class IntroFlowModule { }
